import { render, staticRenderFns } from "./RegisComplete.vue?vue&type=template&id=36c7d07c&scoped=true"
import script from "./RegisComplete.vue?vue&type=script&lang=js"
export * from "./RegisComplete.vue?vue&type=script&lang=js"
import style0 from "./RegisComplete.vue?vue&type=style&index=0&id=36c7d07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7d07c",
  null
  
)

export default component.exports